module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Gold + Midnight Blue Closed.75f14dbc.png";